export default __webpack_public_path__ + "static/media/plugged_by_company_card_icon.46343f01.svg";